/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});


// Sticky nav
(function ($) {
  let didScroll;
  let lastScrollTop = 0;
  const delta = 0;
  const collapsePoint = 650; // In what pixel height from top the navigation will be sticky
  const hidePoint = 380; // In what pixel height from top the navigation will collapse

  $(window).scroll(() => {
    didScroll = true;
    const scroll = $(window).scrollTop();

    if (scroll >= collapsePoint) {
      $('.site-header').addClass('is-sticky');
    } else {
      $('.site-header').removeClass('is-sticky');
    }
  });

  function hasScrolled() {
    const st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If they scrolled down and are past the navbar, add class
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > hidePoint) {
      // Scroll Down
      $('.site-header').addClass('scrolling-down');
    } else {
      // Scroll Up
      // eslint-disable-next-line no-lonely-if
      if (st + $(window).height() < $(document).height()) {
        $('.site-header').removeClass('scrolling-down').addClass('scrolling-up');
      }
    }

    lastScrollTop = st;
  }

  setInterval(() => {
    if (didScroll) {
      hasScrolled();
      didScroll = true;
    }
  }, 250);


}(jQuery));

// Smooth scroll
jQuery(document).ready(function(){
 

  jQuery('a[href^="#"]').on('click',function (e) {
    // e.preventDefault();

    var target = this.hash,
    $target = jQuery(target);

    jQuery('html, body').stop().animate({
     'scrollTop': $target.offset().top -100
    }, 100, function () {
     window.location.hash = target;
    });
  });

});


emergence.init({
  reset: false
});
